import { css } from '@eti/styles';
import { vars } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const colors = {
  hint: vars.colors.signal.information.light,
  error: vars.colors.signal.critical.foreground,
  warning: vars.colors.text
};
const textStyles = type => css`
  color: ${colors[type] || 'inherit'};
  font-size: 0.875rem;
  margin-block-start: 6px;
  margin-inline-start: 8px;
`;
const Message = _ref => {
  let {
    error,
    hint,
    warning
  } = _ref;
  if (hint) {
    return /*#__PURE__*/_jsx("div", {
      className: textStyles('hint'),
      children: hint
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx("div", {
      className: textStyles('error'),
      children: error
    });
  }
  if (warning) {
    return /*#__PURE__*/_jsx("div", {
      className: textStyles('warning'),
      children: warning
    });
  }
  return null;
};
export default Message;
//# sourceMappingURL=Message.js.map